import React, { useState, useRef } from 'react';
import logo from '../../../images/brand/aneevo.jpeg';
import { assumeAccessToken } from '../../../modules/auth/redux/authActions';
import './AneevoLink.scss';

const AneevoLink = () => {
  const [assumeToken, setAssumeToken] = useState('');
  const [redirectUrl, setRedirectUrl] = useState('');
  const [referrerUrl, setReferrerUrl] = useState('');

  const formRef = useRef();

  const handleTransfer = () => {
    assumeAccessToken({
      scope: 'back-office',
      channel_key: 'jtc-brokers',
    }).then((response) => {
      setAssumeToken(response.data.token);
      setRedirectUrl(response.data.redirect_url);
      setReferrerUrl(response.data.referrer_url);

      formRef.current.submit();
    });
  };

  return (
    <div className={'aneevo-link-container'} onClick={handleTransfer}>
      <form method="post" action={redirectUrl + '/auth/assume'} ref={formRef}>
        <input type="hidden" name="token" value={assumeToken} />
        <input type="hidden" name="redirect_uri" value={redirectUrl} />
        <input type="hidden" name="referrer_url" value={referrerUrl} />
      </form>
      <img src={logo} alt="Aneevo" />
    </div>
  );
};

export default AneevoLink;
